import React from "react"
import { Typography } from "@material-ui/core"
import useStyles from "./uploadStyles"
import DropZone from "./DropZone"
import { useTranslation } from "react-i18next"

const UploadPopper = ({ onClose, onSubmit }) => {
	const classes = useStyles()
	const [t] = useTranslation("global")

	const onCancel = () => {
		onClose()
	}

	return (
		<div>
			<div className={classes.row}>
				<Typography variant="h6" className={classes.title}>
					{t("dropZone.uploadFiles")}
				</Typography>
			</div>
			<hr className={classes.dividerLine} />
			<DropZone onSubmit={onSubmit} onCancel={onCancel} />
		</div>
	)
}

export default UploadPopper
